import { Box, BoxProps, styled } from '@mui/material'
import React from 'react'
import { mobileLayoutStyles } from '../../utils/hooks/useIsMobileLayout'

const StyledFilterRow = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 auto',
  flexWrap: 'wrap',
  gap: 8,
  minWidth: 0,
  width: '100%',
  ...mobileLayoutStyles(theme, {
    alignItems: 'stretch',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  }),
  '& .MuiFormControl-root': {
    marginBottom: 0,
    marginTop: 0,
    width: '100%',
  },
  '& .MuiTextField-root': {
    marginBottom: 0,
    marginTop: 0,
    width: '100%',
  },
  '& .MuiAutocomplete-root': {
    width: '100%',
  },
  '& .MuiFormHelperText-root:empty': {
    margin: 0,
    minHeight: 0,
  },
}))

interface ToolbarFilterFieldProps {
  children: React.ReactNode
  minWidth?: number
}

export const ToolbarFilterField: React.FC<ToolbarFilterFieldProps> = ({ children, minWidth = 260 }) => {
  return (
    <Box
      data-testid="toolbar-filter-field"
      sx={{
        flex: { md: '0 1 auto', xs: '1 1 100%' },
        minWidth: { md: minWidth, xs: '100%' },
        width: { md: 'auto', xs: '100%' },
      }}
    >
      {children}
    </Box>
  )
}

interface ToolbarFilterRowProps {
  actions?: React.ReactNode
  children: React.ReactNode
  sx?: BoxProps['sx']
}

const ToolbarFilterRow: React.FC<ToolbarFilterRowProps> = ({ actions, children, sx }) => {
  return (
    <StyledFilterRow data-testid="toolbar-filter-row" sx={sx}>
      {children}
      {actions ? (
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexShrink: 0,
            justifyContent: { md: 'flex-start', xs: 'flex-end' },
            order: { md: 0, xs: 2 },
            paddingTop: { md: 0, xs: 0.5 },
            width: { md: 'auto', xs: '100%' },
            ...mobileLayoutStyles(theme, {
              borderTop: `1px solid ${theme.palette.divider}`,
            }),
          })}
        >
          {actions}
        </Box>
      ) : null}
    </StyledFilterRow>
  )
}

export default ToolbarFilterRow
